import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'

dayjs.extend(duration)

export const sec2time = (seconds: number, format: string) =>
  dayjs.duration(seconds * 1000).format(format)

export const getCourseTotalTime = (totalSeconds: number) => {
  const duration = dayjs.duration(totalSeconds, 'seconds')
  const hours = Math.floor(duration.asHours())
  const minutes = duration.minutes()

  return minutes === 0 ? `${hours}시간` : `${hours}시간 ${minutes}분`
}
